module.exports = __webpack_public_path__ + "static/media/guia.3dbbe842.pdf";